import type { NewRelic } from '@/types';

class SafeNewRelic implements NewRelic {
  private _newrelic: NewRelic;

  constructor() {
    this._newrelic = window.newrelic;
  }

  get newrelic() {
    return (this._newrelic ||= window.newrelic);
  }

  addPageAction(name: string, attributes?: object) {
    if (!this.newrelic) {
      console.log(`NewRelic unavailable for page action: ${name}`);
      return;
    }
    this.newrelic.addPageAction(name, attributes);
  }

  setCustomAttribute(key: string, value: string) {
    if (!this.newrelic) {
      console.log(`NewRelic unavailable for custom attribute: ${key}`);
      return;
    }
    this.newrelic.setCustomAttribute(key, value);
  }
}

export const newrelic = new SafeNewRelic();
